import _getIterator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/get-iterator";
import "core-js/modules/es6.array.find";
import _objectSpread from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import router from "@/router/router";
import routerTempHelpers from "@/utils/routerTempHelpers";
import store from "@/store/index";
import * as types from "@/store/constants/types";
export var routerStackModule = {
  routerStack: [],
  homeActiveIndex: 0
};
var isRouterCanGo = true;

var setRouterCanGO = function setRouterCanGO() {
  isRouterCanGo = false;
  var timer = setTimeout(function () {
    isRouterCanGo = true;
    clearTimeout(timer);
  }, 200);
};

export var updateHomeActiveIndex = function updateHomeActiveIndex(num) {
  routerStackModule.homeActiveIndex !== num && (routerStackModule.homeActiveIndex = num);
};
export var routerReplace = function routerReplace(payload) {
  if (isRouterCanGo) {
    setRouterCanGO();
    var temp_stack = routerStackModule.routerStack.shift();
    removeTempQuery(temp_stack);
    routerStackModule.routerStack.unshift(payload);
    console.log("routerStack: routerReplace", routerStackModule);
  }
};
export var routerGoBack = function routerGoBack(payLoad) {
  if (isRouterCanGo) {
    setRouterCanGO();
    var pathNumber = Math.abs(payLoad);

    if (routerStackModule.routerStack.length === 0) {
      console.log("to home>>>>>>>>>");
      store.dispatch(types.ROUTER_REPLACE, {
        name: "home"
      });
    } else {
      var temp_stack_arr = routerStackModule.routerStack.splice(0, pathNumber);
      temp_stack_arr.forEach(function (v) {
        removeTempQuery(v);
      });
    }

    console.log("routerStack back:", routerStackModule);
  }
};
export var getRouterQuery = function getRouterQuery(routerInstance) {
  return JSON.parse(routerInstance.query.data);
};
export var routerPush = function routerPush(payLoad) {
  try {
    if (isRouterCanGo) {
      setRouterCanGO();
      router.push(payLoad);
      routerStackModule.routerStack.unshift(payLoad);
      console.log("routerStack push:", routerStackModule);
    }
  } catch (e) {}
};
export var changeRouterQuery = function changeRouterQuery(payLoad) {
  var name = payLoad.name,
      query = payLoad.query;
  var routerStack = routerStackModule.routerStack;
  var findIndex = routerStack.findIndex(function (route) {
    return route.name === name;
  });

  if (findIndex && findIndex > -1) {
    var newRouter = _objectSpread({}, routerStack[findIndex]);

    newRouter.query = _objectSpread({}, newRouter.query, query);
    routerStack.splice(findIndex, 1, newRouter);
  } // console.log("routerStack:", routerStackModule);

};
export var routerInclude = function routerInclude(payLoad) {
  var routerStack = routerStackModule.routerStack;
  var findRoute = routerStack.find(function (route) {
    return route.name === payLoad;
  });

  if (findRoute === undefined || findRoute === null) {
    return false;
  } else {
    return findRoute;
  }
};
export var routerIncludeTimes = function routerIncludeTimes(payLoad) {
  var routerStack = routerStackModule.routerStack;
  var nums = 0;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _getIterator(routerStack), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var route = _step.value;

      if (route.name === payLoad) {
        nums++;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return nums;
};

var removeTempQuery = function removeTempQuery(payload) {
  if (payload && payload.query) {
    routerTempHelpers.destroyTempQuery(payload.query);
  }
};